import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import App from './App';
import { AuthProvider } from './contexts/JWTContext';
import { LicenseInfo } from '@mui/x-license-pro';
import { SettingsProvider } from './contexts/SettingsContext';
import store from './store';
import { LICENSE_KEY } from './constants';

/** Chrome fires this when ResizeObserver runs nested layouts (common with MUI Drawer/Tabs). Harmless; avoid dev overlay noise. */
window.addEventListener(
  'error',
  (event) => {
    if (
      typeof event.message === 'string'
      && event.message.includes('ResizeObserver loop')
    ) {
      event.stopImmediatePropagation();
    }
  },
  true,
);

// Only skip license key on localhost - dev and production environments will use it
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
if (!isLocalhost) {
  LicenseInfo.setLicenseKey(LICENSE_KEY);
}
ReactDOM.render(
  <StrictMode>
    <HelmetProvider>
      <ReduxProvider store={store}>
        <StyledEngineProvider injectFirst>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SettingsProvider>
              <BrowserRouter>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </BrowserRouter>
            </SettingsProvider>
          </LocalizationProvider>
        </StyledEngineProvider>
      </ReduxProvider>
    </HelmetProvider>
  </StrictMode>, document.getElementById('root')
);
